import axios from "axios";
import { AssessmentService_URL } from "../Url";
import HashMap from "hashmap";
import axiosInstance from "../Intercepter/axiosInstance";

var map = new HashMap();

function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}

export const SaveAssessmentActions = {
  SAVE_ASSESSMENT: "SAVE_ASSESSMENT",
  SAVE_ASSESSMENT_STATUS: "SAVE_ASSESSMENT_STATUS",
  SAVE_ASSESSMENT_SUCCESS: "SAVE_ASSESSMENT_SUCCESS",
  SAVE_ASSESSMENT_FAILURE: "SAVE_ASSESSMENT_FAILURE",
};

export function SaveAssessmentRequest() {
  return {
    type: SaveAssessmentActions.SAVE_ASSESSMENT,
    isPosting: true,
  };
}

export function SaveAssessmentSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: SaveAssessmentActions.SAVE_ASSESSMENT_SUCCESS,
      payload: props,
    });
  };
}

export function SaveAssessmentFailure(error) {
  return {
    type: SaveAssessmentActions.SAVE_ASSESSMENT_FAILURE,
    payload: error,
  };
}

export function SaveAssessmentError(error) {
  return {
    type: SaveAssessmentActions.SAVE_ASSESSMENT_FAILURE,
    payload: error,
  };
}

export function saveAssessmentResponse(props, param, submitToReviewer, access_token) {
  let finalUrl = `${AssessmentService_URL}/Apc_Persist/Amc_30/saveAssessmentResponseForOutsideUsers?userId=${param}`;
  if(submitToReviewer){
    finalUrl = `${AssessmentService_URL}/Apc_Persist/Amc_30/saveAssessmentResponseForOutsideUsers?userId=${param}&submitToReviewer=true`
  }else{
    finalUrl = `${AssessmentService_URL}/Apc_Persist/Amc_30/saveAssessmentResponseForOutsideUsers?userId=${param}`
  }
  return (dispatch) =>
    axios({
      method: "post",
      data: props,
      url: finalUrl,
      headers: {
        authorization: "Bearer " + access_token,
      },
    })
      .then((response) => {
        // dispatch(SaveAssessmentRequest());
        if (response.status >= 200 && response.status < 300) {
          // dispatch(SaveAssessmentSuccess(response));
          return response;
        } else if (response.status === 401) {
        } else {
          const error = new Error(response.statusText);
          // dispatch(SaveAssessmentError(error));
          throw error;
        }
      })
      .catch((err) => {
        let errorMessage = "Unknown Error"; // Default error message
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              errorMessage = err.message || "Bad Request";
              dispatch(SaveAssessmentError(errorMessage));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              errorMessage = err.message || "Not Found";
              dispatch(SaveAssessmentError(errorMessage));
              break;
            case 406:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              errorMessage = err.message || "Not Acceptable";
              dispatch(SaveAssessmentError(errorMessage));
              break;
            case 500:
              errorMessage = "Server Error";
              dispatch(SaveAssessmentError(errorMessage));
              break;
            default:
              errorMessage = (err.response.data.message || err.response.data.error.message) || "Unknown Error";
              dispatch(SaveAssessmentError(errorMessage));
              break;
          }
        } else {
          // Dispatch any other type of error (e.g., network issues)
          errorMessage = "Network Error";
          dispatch(SaveAssessmentError(errorMessage));
        }

        throw new Error(errorMessage); // Throw the error for further handling
      });
}

export function saveAssessmentOneByOneQuestionResponse(props, access_token) {
  return (dispatch) =>
    axios({
      method: "post",
      data: props,
      url: `${AssessmentService_URL}/Apc_Persist/Amc_30/saveAssessmentResponseQuestionVice`,
      headers: {
        authorization: "Bearer " + access_token,
      },
    })
      .then((response) => {
        // dispatch(SaveAssessmentRequest());
        if (response.status >= 200 && response.status < 300) {
          // dispatch(SaveAssessmentSuccess(response));
          return response;
        } else if (response.status === 401) {
        } else {
          const error = new Error(response.statusText);
          // dispatch(SaveAssessmentError(error));
          throw error;
        }
      })
      .catch((err) => {
        let errorMessage = "Unknown Error"; // Default error message
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              errorMessage = err.message || "Bad Request";
              dispatch(SaveAssessmentError(errorMessage));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              errorMessage = err.message || "Not Found";
              dispatch(SaveAssessmentError(errorMessage));
              break;
            case 406:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              errorMessage = err.message || "Not Acceptable";
              dispatch(SaveAssessmentError(errorMessage));
              break;
            case 500:
              errorMessage = "Server Error";
              dispatch(SaveAssessmentError(errorMessage));
              break;
            default:
              errorMessage = (err.response.data.message || err.response.data.error.message) || "Unknown Error";
              dispatch(SaveAssessmentError(errorMessage));
              break;
          }
        } else {
          // Dispatch any other type of error (e.g., network issues)
          errorMessage = "Network Error";
          dispatch(SaveAssessmentError(errorMessage));
        }

        throw new Error(errorMessage); // Throw the error for further handling
      });
}

// clear  details
export const ClearFormDetailsActions = {
  CLEAR_FORM_DETAILS: "CLEAR_FORM_DETAILS",
};

export function clearFormData() {
  return (dispatch) => dispatch(clearFormDetails());
}

export function clearFormDetails() {
  return {
    type: ClearFormDetailsActions.CLEAR_FORM_DETAILS,
  };
}

// get  details by id

///////GET LOCATION BY ID

export const GetAssessmentDetailsActions = {
  FETCH_ASSESSMENT_DETAILS: "FETCH_ASSESSMENT_DETAILS",
  FETCH_ASSESSMENT_DETAILS_STATUS: "FETCH_ASSESSMENT_DETAILS_STATUS",
  FETCH_ASSESSMENT_DETAILS_FULFILLED: "FETCH_ASSESSMENT_DETAILS_FULFILLED",
  FETCH_ASSESSMENT_DETAILS_REJECTED: "FETCH_ASSESSMENT_DETAILS_REJECTED",
  SET_EDIT_ERROR: "SET_EDIT_ERROR",
};

export function getTemplateDetails(params) {
  return (dispatch) =>
    axios({
      method: "post",
      url:
        `${AssessmentService_URL}/Apc_View/Amc_30/getTemplateByTemplateId/` +
        params.id,
      headers: {
        transactionId: "1",
        Authorization: "Bearer " + params.access_token,
      },
    })
      .then((response) => {
        dispatch(getAssessmentDetailsRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(getAssessmentDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getAssessmentDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getAssessmentDetailsError(err));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getAssessmentDetailsError(err));
              break;
            case 406:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getAssessmentDetailsError(err));
              break;
            case 500:
              dispatch(getAssessmentDetailsError("Server Error"));
              break;
            default:
              dispatch(getAssessmentDetailsError("Unknown Error"));
              break;
          }
        } else {
          // dispatch(logout());
        }
      });
}

export function getViewAssessmentDetails(params) {
  return (dispatch) =>
    axios({
      method: "post",
      url:
        `${AssessmentService_URL}/Apc_Persist/Amc_30/getAssessmentResponseForOutsideUser?assessmentId=${params.id}&emailId=${params.userEmail}`,
      headers: {
        transactionId: "1",
        Authorization: "Bearer " + params.access_token,
      },
    })
      .then((response) => {
        // dispatch(getAssessmentDetailsRequest());
        if (response.status >= 200 && response.status < 300) {
          // dispatch(getAssessmentDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          // dispatch(getAssessmentDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getAssessmentDetailsError(err));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getAssessmentDetailsError(err));
              break;
            case 406:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getAssessmentDetailsError(err));
              break;
            case 500:
              dispatch(getAssessmentDetailsError("Server Error"));
              break;
            default:
              dispatch(getAssessmentDetailsError("Unknown Error"));
              break;
          }
        } else {
          // dispatch(logout());
        }
      });
}

export function getAssessmentDetailsRequest() {
  return {
    type: GetAssessmentDetailsActions.FETCH_ASSESSMENT_DETAILS,
    isPosting: true,
  };
}
export function getAssessmentDetailsError(error) {
  return {
    type: GetAssessmentDetailsActions.FETCH_ASSESSMENT_DETAILS_REJECTED,
    payload: error,
  };
}

export function getAssessmentDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: GetAssessmentDetailsActions.FETCH_ASSESSMENT_DETAILS_FULFILLED,
      payload: props,
    });
  };
}

export function getAssessmentDetailsStatus() {
  return (dispatch) => dispatch(getAssessmentDetailsStatusRequest());
}
export function getAssessmentDetailsStatusRequest() {
  return {
    type: GetAssessmentDetailsActions.FETCH_ASSESSMENT_DETAILS_STATUS,
  };
}

export function setDetailsError() {
  return (dispatch) => dispatch(getAssessmentDetailsErrorRequest());
}
export function getAssessmentDetailsErrorRequest() {
  return {
    type: GetAssessmentDetailsActions.SET_EDIT_ERROR,
  };
}

export const GetActiveAssessmentActions = {
  FETCH_ACTIVE_ASSESSMENT: "FETCH_ACTIVE_ASSESSMENT",
  FETCH_ACTIVE_ASSESSMENT_STATUS: "FETCH_ACTIVE_ASSESSMENT_STATUS",
  FETCH_ACTIVE_ASSESSMENT_FULFILLED: "FETCH_ACTIVE_ASSESSMENT_FULFILLED",
  FETCH_ACTIVE_ASSESSMENT_REJECTED: "FETCH_ACTIVE_ASSESSMENT_REJECTED",
};
export function getActiveAssessmentList(params) {
  return (dispatch) =>
    axios({
      method: "post",
      // data: JSON.stringify( {
      //           ...params
      //         }),
      url: `${AssessmentService_URL}/Apc_View/Amc_9/getAllAssessmentMasterPagination?start=0&length=0&sortOrder=desc&sortField=id&booleanfield=true`,
      headers: {
        transactionId: "1",
        "Content-Type": "application/json",
        Authorization: "Bearer " + params.access_token,
      },
    })
      .then((response) => {
        dispatch(getActiveAssessmentListRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(getActiveAssessmentListSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getActiveAssessmentListError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getActiveAssessmentListError(err));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getActiveAssessmentListError(err));
              break;
            case 406:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getActiveAssessmentListError(err));
              break;
            case 500:
              dispatch(getActiveAssessmentListError("Server Error"));
              break;
            default:
              dispatch(getActiveAssessmentListError("Unknown Error"));
              break;
          }
        } else {
          // dispatch(logout());
        }
      });
}

export function getActiveAssessmentListRequest() {
  return {
    type: GetActiveAssessmentActions.FETCH_ACTIVE_ASSESSMENT,
    isPosting: true,
  };
}
export function getActiveAssessmentListError(error) {
  return {
    type: GetActiveAssessmentActions.FETCH_ACTIVE_ASSESSMENT_REJECTED,
    payload: error,
  };
}

export function getActiveAssessmentListSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: GetActiveAssessmentActions.FETCH_ACTIVE_ASSESSMENT_FULFILLED,
      payload: props,
    });
  };
}

export function getActiveAssessmentListStatus() {
  return (dispatch) => dispatch(getActiveAssessmentListStatusRequest());
}
export function getActiveAssessmentListStatusRequest() {
  return {
    type: GetActiveAssessmentActions.FETCH_ACTIVE_ASSESSMENT_STATUS,
  };
}



export const GetAssessmentByIdDetailsActions = {
  FETCH_ASSESSMENT_DETAILS_BY_ID: "FETCH_ASSESSMENT_DETAILS_BY_ID",
  FETCH_ASSESSMENT_DETAILS_BY_ID_STATUS: "FETCH_ASSESSMENT_DETAILS_BY_ID_STATUS",
  FETCH_ASSESSMENT_DETAILS_BY_ID_FULFILLED: "FETCH_ASSESSMENT_DETAILS_BY_ID_FULFILLED",
  FETCH_ASSESSMENT_DETAILS_BY_ID_REJECTED: "FETCH_ASSESSMENT_DETAILS_BY_ID_REJECTED",
  SET_EDIT_ERROR: "SET_EDIT_ERROR",
};


export function getViewAssessmentByIdDetails(params) {
  return (dispatch) =>
    axiosInstance({
      method: "post",
      url:
        `${AssessmentService_URL}/Apc_Persist/Amc_30/getAssessmentResponseForLoggedInUser?assessmentId=` +
        params.id,
      headers: {
        transactionId: "1",
        Authorization: "Bearer " + params.access_token,
      },
    })
    .then((response) => {
        dispatch(GetAssessmentByIdDetailsRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(GetAssessmentByIdDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(GetAssessmentByIdDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(GetAssessmentByIdDetailsError(err));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(GetAssessmentByIdDetailsError(err));
              break;
            case 406:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(GetAssessmentByIdDetailsError(err));
              break;
            case 500:
              dispatch(GetAssessmentByIdDetailsError("Server Error"));
              break;
            default:
              dispatch(GetAssessmentByIdDetailsError("Unknown Error"));
              break;
          }
        } else {
          // dispatch(logout());
        }
      });
      
}

export function GetAssessmentByIdDetailsRequest() {
  return {
    type: GetAssessmentByIdDetailsActions.FETCH_ASSESSMENT_DETAILS_BY_ID,
    isPosting: true,
  };
}
export function GetAssessmentByIdDetailsError(error) {
  return {
    type: GetAssessmentByIdDetailsActions.FETCH_ASSESSMENT_DETAILS_BY_ID_REJECTED,
    payload: error,
  };
}

export function GetAssessmentByIdDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: GetAssessmentByIdDetailsActions.FETCH_ASSESSMENT_DETAILS_BY_ID_FULFILLED,
      payload: props,
    });
  };
}

export function GetAssessmentByIdDetailsStatus() {
  return (dispatch) => dispatch(GetAssessmentByIdDetailsStatusRequest());
}
export function GetAssessmentByIdDetailsStatusRequest() {
  return {
    type: GetAssessmentByIdDetailsActions.FETCH_ASSESSMENT_DETAILS_BY_ID_STATUS,
  };
}
